{
  "title": "Fournisseurs",
  "subtitle": "Les entreprises et les personnes auprès de qui vous achetez : ce que vous avez reçu, ce que vous avez payé, ce que vous devez encore.",
  "inactive": "Inactif",
  "list": {
    "new": "Nouveau fournisseur",
    "search": "Nom, numéro, téléphone ou matricule fiscal",
    "statusLabel": "Statut",
    "status": {
      "active": "Actifs",
      "inactive": "Inactifs",
      "all": "Tous les fournisseurs"
    },
    "owed": "Encore à payer",
    "sort": "Trier",
    "sorts": {
      "name_asc": "Nom, de A à Z",
      "name_desc": "Nom, de Z à A",
      "balance_desc": "Plus grand solde d'abord",
      "createdAt_desc": "Plus récents d'abord"
    },
    "clear": "Effacer les filtres",
    "showing_one": "{{first}} à {{last}} sur {{total}} fournisseur",
    "showing_other": "{{first}} à {{last}} sur {{total}}"
  },
  "empty": {
    "title": "Aucun fournisseur pour l'instant",
    "text": "Ajoutez ici les fournisseurs auprès de qui vous achetez, ou enregistrez-les en recevant leurs marchandises."
  },
  "noMatch": {
    "title": "Aucun fournisseur trouvé",
    "text": "Essayez un autre nom, numéro ou téléphone, ou affichez aussi les fournisseurs inactifs."
  },
  "columns": {
    "supplier": "Fournisseur",
    "balance": "Solde",
    "open": "Réceptions ouvertes",
    "receipt": "Réception",
    "date": "Date",
    "theirReference": "Leur référence",
    "status": "Statut",
    "payment": "Paiement",
    "pays": "Paie",
    "allocated": "Montant"
  },
  "fields": {
    "name": "Nom",
    "contactName": "Interlocuteur",
    "phone": "Téléphone",
    "email": "E-mail",
    "address": "Adresse",
    "city": "Ville",
    "taxId": "Matricule fiscal",
    "notes": "Notes"
  },
  "form": {
    "newTitle": "Nouveau fournisseur",
    "newHint": "Seul le nom est nécessaire ; le reste peut venir plus tard.",
    "editTitle": "Modifier {{number}}",
    "create": "Ajouter le fournisseur",
    "created": "Fournisseur {{number}} ajouté",
    "saved": "Fournisseur enregistré",
    "taxIdHint": "Identifiant fiscal du fournisseur",
    "notesHint": "Conditions de paiement, horaires, tout ce que l'équipe doit savoir."
  },
  "details": {
    "created": "Ajouté",
    "updated": "Dernière modification"
  },
  "actions": {
    "edit": "Modifier",
    "pay": "Enregistrer un paiement",
    "receive": "Recevoir du stock",
    "deactivate": "Désactiver",
    "activate": "Activer",
    "deactivateTitle": "Désactiver ce fournisseur ?",
    "deactivateText": "Il ne figure plus dans les listes où l'on choisit un fournisseur. Ses réceptions, ses paiements et son solde restent, et vous pourrez le réactiver.",
    "activateTitle": "Activer ce fournisseur ?",
    "activateText": "Il pourra de nouveau être choisi à la réception des marchandises.",
    "deactivated": "Fournisseur désactivé",
    "activated": "Fournisseur activé"
  },
  "figures": {
    "balance": "Solde",
    "openReceipts_zero": "Rien ne reste à payer sur ses réceptions",
    "openReceipts_one": "{{count}} réception pas entièrement payée",
    "openReceipts_other": "{{count}} réceptions pas entièrement payées",
    "creditHint": "Payé d'avance : le fournisseur vous doit ce montant.",
    "amountDue": "À payer",
    "receipts_zero": "Aucune réception pour l'instant",
    "receipts_one": "{{count}} réception · marchandises {{value}}",
    "receipts_other": "{{count}} réceptions · marchandises {{value}}",
    "paid": "Payé",
    "advance": "Dont {{amount}} pas encore affecté",
    "scheduled": "Prévu",
    "scheduledHint": "Chèques, traites et crédits pas encore réglés."
  },
  "tabs": {
    "receipts": "Réceptions",
    "payments": "Paiements",
    "statement": "Relevé",
    "details": "Coordonnées"
  },
  "receipts": {
    "empty": "Aucune réception de ce fournisseur pour l'instant.",
    "scheduled": "{{amount}} prévu"
  },
  "statement": {
    "empty": "Rien reçu de ce fournisseur ni payé pour l'instant.",
    "document": "Document",
    "due": "À payer"
  },
  "receiptStatus": {
    "unpaid": "Non payée",
    "partlyPaid": "Payée en partie",
    "paid": "Payée"
  },
  "paymentStatus": {
    "pending": "En attente",
    "completed": "Payé",
    "cancelled": "Annulé"
  },
  "picker": {
    "placeholder": "Chercher un fournisseur ou taper un nom",
    "save": "Enregistrer « {{name}} » comme fournisseur",
    "typedOnly": "Saisi seulement : aucun fournisseur n'est enregistré si vous ne le faites pas.",
    "unlink": "Retirer {{name}}"
  },
  "receipt": {
    "title": "Paiements",
    "afterValidation": "Enregistrez ce que vous payez pour cette réception une fois validée. Un paiement d'avance peut déjà être enregistré sur le fournisseur.",
    "goodsValue": "Valeur des marchandises",
    "amountDue": "Montant à payer",
    "isGoodsValue": "La valeur des marchandises",
    "changeDue": "Modifier le montant à payer",
    "dueTitle": "Montant à payer au fournisseur",
    "dueHint": "Le total de la facture du fournisseur, avec la TVA, le transport ou le timbre. Les marchandises valent {{amount}} en stock.",
    "useGoodsValue": "Reprendre la valeur des marchandises",
    "dueSaved": "Montant à payer enregistré",
    "open": "Reste à payer",
    "noPayments": "Aucun paiement pour l'instant.",
    "advances": "Affecter un montant déjà payé à ce fournisseur"
  },
  "pay": {
    "title": "Enregistrer un paiement",
    "noSupplier": "Pour une réception d'un fournisseur non enregistré",
    "method": "Mode",
    "amount": "Montant",
    "date": "Date",
    "status": "Statut",
    "completedNow": "Payé maintenant",
    "pendingLater": "À régler plus tard",
    "pendingHint": "Il apparaît comme prévu et ne compte comme payé que lorsque vous le marquez payé.",
    "deferredHint": "Un crédit est une promesse de payer : il reste prévu jusqu'au paiement, et vous dites alors comment.",
    "number": "Numéro",
    "reference": "Référence",
    "bank": "Banque",
    "dueDate": "Échéance",
    "receipts": "Réceptions qu'il paie",
    "receiptsHint": "Ce qui n'est donné à aucune réception reste une avance sur le fournisseur.",
    "receiptsAllHint": "Un fournisseur non enregistré ne peut pas garder d'avance : tout le montant va à la réception.",
    "shareOldest": "Répartir sur les plus anciennes",
    "noOpenReceipts": "Aucune réception n'attend de paiement.",
    "openAmount": "{{amount}} restant",
    "shareOf": "Montant pour {{number}}",
    "allocated": "Affecté aux réceptions",
    "advance": "Avance sur le fournisseur",
    "note": "Note",
    "proofs": "Justificatifs",
    "addProof": "Ajouter des fichiers",
    "proofsHint": "Reçus, avis de virement, photos de chèques : PDF ou images, envoyés avec le paiement.",
    "record": "Enregistrer le paiement",
    "recorded": "Paiement {{number}} enregistré",
    "twinTitle": "{{number}} semble identique",
    "twinText": "Un paiement de ce montant, par ce mode, ce jour-là, est déjà enregistré pour ce fournisseur.",
    "recordAnyway": "L'enregistrer quand même"
  },
  "allocate": {
    "title": "Répartir {{number}}",
    "description": "{{amount}} entre les réceptions du fournisseur.",
    "upTo": "jusqu'à {{amount}}",
    "over": "Plus que le paiement",
    "saved": "Paiement réparti de nouveau"
  },
  "payment": {
    "payee": "Payé à",
    "pays": "Réceptions qu'il paie",
    "paysNothing": "Aucune réception : une avance sur le fournisseur.",
    "unallocated": "{{amount}} de ce paiement n'est pas encore affecté à une réception.",
    "settledCredit": "enregistré comme {{name}}",
    "dueOn": "échéance {{date}}",
    "recordedBy": "Enregistré par",
    "completedOn": "Payé le",
    "complete": "Marquer payé",
    "completeTitle": "Marquer {{number}} comme payé",
    "completeHint": "Le jour où le chèque a été encaissé ou la traite payée.",
    "completeCreditHint": "Le jour du paiement, et comment il a été payé.",
    "paidWith": "Payé par",
    "chooseMethod": "Choisir un mode",
    "completedToast": "Paiement marqué payé",
    "allocate": "Répartir de nouveau",
    "cancel": "Annuler le paiement",
    "cancelTitle": "Annuler {{number}} ?",
    "cancelHint": "Il reste dans la liste comme annulé et ne compte nulle part. Un chèque impayé, une traite non honorée, une saisie en double.",
    "cancelReason": "Pourquoi",
    "cancelledToast": "Paiement annulé",
    "cancelledBy": "Annulé par {{name}}, {{date}}"
  },
  "payments": {
    "title": "Paiements fournisseurs",
    "subtitle": "L'argent payé aux fournisseurs, et ce qui est prévu : chèques à encaisser, traites et crédits à leur échéance.",
    "new": "Nouveau paiement",
    "search": "Numéro, référence ou fournisseur",
    "allStatuses": "Tous les statuts",
    "allMethods": "Tous les modes",
    "totalCompleted": "Payé :",
    "totalPending": "Prévu :",
    "empty": "Aucun paiement trouvé",
    "emptyText": "Les paiements s'enregistrent depuis la page d'un fournisseur ou une réception.",
    "emptySupplier": "Aucun paiement à ce fournisseur pour l'instant.",
    "advance": "Avance",
    "chooseSupplier": "Qui est payé ?",
    "continue": "Continuer",
    "showing_one": "{{first}} à {{last}} sur {{total}} paiement",
    "showing_other": "{{first}} à {{last}} sur {{total}}"
  }
}
